import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-request-org-deletion.component.less'],
  templateUrl: './tellent-request-org-deletion.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
    EmailMailgunIfDirective,
    EmailInfoboxComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentRequestOrgDeletionTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentRequestOrgDeletionTemplateData>;
}

export type TellentRequestOrgDeletionTemplateData = {
  header: string;
  subheader_html: string;
  infobox_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
};

export const TellentRequestOrgDeletionTemplateMocks: TellentRequestOrgDeletionTemplateData[] = [
  {
    header: 'We deleted your company account',
    subheader_html: `Your company account <b>%{companyName}</b> has been deleted.`,
    infobox_html:
      'All associated data will be <b>permanently deleted in %{days} days</b>. If you want to keep your account, please contact our support team.',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
  },
];
